export default function Line() {
  return (
    <div className="flex justify-center">
      <div className="w-[90vw]">
        <hr className="border-t border border-light-text dark:border-dark-text my-12 w-full" />
      </div>
    </div>
  );
}
